// @flow
import React from 'react';

const setRouteChange = (
  props,
  pathname,
  hash_value = '',
  location_value = '',
  id = '',
  state = ''
) => {
  let locationString = window.location.toString().split('?');
  let utm_params = locationString[1];
  if (pathname !== '#') {
    props.history.push({
      pathname: pathname,
      search: utm_params,
      hash_value: hash_value,
      location_value: location_value,
      id: id,
      state: state,
    });
  }
};

export const RouteUtil = {
  setRouteChange,
};
